import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from "moment";
import 'moment/locale/pt-br';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis,
  Legend,
  Tooltip as RechartsTooltip,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts';

import Header from '../../components/Header';
import ModalShift from '../../components/modals/ModalShift';
import InputDate from '../../components/inputs/InputDate';
import { Loading, TableLoading } from '../../components/ResponsiveLoading';

import dash from '../../assets/images/dash.svg';
import pin2 from '../../assets/images/pin2.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';

import closeCircle from '../../assets/images/closeCircle.svg';
import calendar6 from '../../assets/images/calendar6.svg';
import calendar7 from '../../assets/images/calendar7.svg';
import calendar8 from '../../assets/images/calendar8.svg';
import check2 from '../../assets/images/check2.svg';
import talk2 from '../../assets/images/talk2.svg';
import tooltip from '../../assets/images/tooltip.svg';
import tooltip2 from '../../assets/images/tooltip2.svg';
import plusCircle from '../../assets/images/plusCircle.svg';
import vv from '../../assets/images/visita-virtual.svg';
import api from '../../services/api';
import getUserInfo from "../../services/getUserInfo";
import { createUrlParamsFromObject } from '../../services/helpers';

import './styles.css';
import ModalPeriodo from '../../components/modals/ModalPeriodo';
import ModalRegion from '../../components/modals/ModalRegion';

const baseRankings = {
  corretores: [], 
  gerentes: [], 
  superintendentes: []
};

const labels = {
  ativados: 'Leads ativados',
  aguardando: 'Aguardando ativação',
  expirados: 'Expirados'
};

export const Leads = () => {
  const today = new Date();

  const [shifts, setShifts] = useState([]);
  const [regionais, setRegionais] = useState([]);
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalShiftsNumber, setTotalShiftsNumber] = useState(0);
  const [periodo, setPeriodo] = useState('diario');
  const [historicoLeads, setHistoricoLeads] = useState(null);

  const [rankingLeadsAtivados, setRankingLeadsAtivados] = useState(baseRankings);
  const [rankingLeadsExpirados, setRankingLeadsExpirados] = useState(baseRankings);

  const [loadingShifts, setLoadingShifts] = useState(true);
  const [loadingHistoricoLeads, setLoadingHistoricoLeads] = useState(true);
  const [loadingEvolucaoLeads, setLoadingEvolucaoLeads] = useState(true);

  const [loadingRankingLeadsAtivados, setLoadingRankingLeadsAtivados] = useState(true);
  const [loadingRankingLeadsExpirados, setLoadingRankingLeadsExpirados] = useState(true);

  const [plantoesHistorico, setPlantoesHistorico] = useState([]);
  const [regiaoHistorico, setRegiaoHistorico] = useState(null);
  const [showModalHistoricoRegiao, setShowModalHistoricoRegiao] = useState(false);
  const [showModalHistoricoPlantoes, setShowModalHistoricoPlantoes] = useState(false);
  const [dataInicialHistorico, setDataInicialHistorico] = useState(today);
  const [dataFinalHistorico, setDataFinalHistorico] = useState(today);

  const [showModalEvolucaoRegiao, setShowModalEvolucaoRegiao] = useState(false);
  const [showModalEvolucaoPlantoes, setShowModalEvolucaoPlantoes] = useState(false);
  const [showModalEvolucaoPeriodo, setShowModalEvolucaoPeriodo] = useState(false);
  const [regiaoEvolucao, setRegiaoEvolucao] = useState(null);
  const [plantoesEvolucao, setPlantoesEvolucao] = useState([]);

  const [showModalRankingAtivadosRegiao, setShowModalRankingAtivadosRegiao] = useState(false);
  const [showModalRankingExpiradosRegiao, setShowModalRankingExpiradosRegiao] = useState(false);
  const [regiaoRankingAtivados, setRegiaoRankingAtivados] = useState({});
  const [regiaoRankingExpirados, setRegiaoRankingExpirados] = useState({});
  const [dataInicialRankingAtivados, setDataInicialRankingAtivados] = useState(today);
  const [dataFinalRankingAtivados, setDataFinalRankingAtivados] = useState(today);
  const [dataInicialRankingExpirados, setDataInicialRankingExpirados] = useState(today);
  const [dataFinalRankingExpirados, setDataFinalRankingExpirados] = useState(today);

  const [evolucaoData, setEvolucaoData] = useState([]);

  const [userInfo, setUserInfo] = useState({});

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
    });

    getShifts();
  }, []);

  useEffect(() => {
    if(plantoesHistorico.length > 0){
      getHistoricoLeads();
    }
  }, [dataInicialHistorico, dataFinalHistorico, plantoesHistorico])

  useEffect(() => {
    getRankingLeadsAtivados();
  }, [dataInicialRankingAtivados, dataFinalRankingAtivados, regiaoRankingAtivados]);

  useEffect(() => {
    getRankingLeadsExpirados();
  }, [dataInicialRankingExpirados, dataFinalRankingExpirados, regiaoRankingExpirados]);

  useEffect(() => {
    if(plantoesEvolucao.length > 0){
      getEvolucaoLeads();
    }
  }, [periodo, plantoesEvolucao]);

  useEffect(() => {
    getPlantoesRegiaoEvolucao();
  }, [regiaoEvolucao]);

  useEffect(() => {
    getPlantoesRegiaoHistorico();
  }, [regiaoHistorico]);

  const getPlantoesRegiaoHistorico = () => {
    let ids = [];

    if(regiaoHistorico?.id === null || regiaoHistorico?.id === undefined){
      ids = shifts;
    } else {
      regionais.map(regional => {
        if(regional.id === regiaoHistorico.id){
          regional.plantoes.map(plantao => {
            ids.push(plantao.id);
          })
        }
      });
    }

    setPlantoesHistorico(ids);
  }

  const getPlantoesRegiaoEvolucao = () => {
    let ids = [];

    if(regiaoEvolucao?.id === null || regiaoEvolucao?.id === undefined){
      ids = shifts;
    } else {
      regionais.map(regional => {
        if(regional.id === regiaoEvolucao.id){
          regional.plantoes.map(plantao => {
            ids.push(plantao.id);
          })
        }
      });
    }

    setPlantoesEvolucao(ids);
  }

  const getHistoricoLeads = () => {
    setLoadingHistoricoLeads(true);

    const filterRegional = (plantoesHistorico.length === totalShiftsNumber)
      ? null
      : plantoesHistorico.join(',');

    api.get('/leads/historico', {
      params: {
        date_start: moment(dataInicialHistorico).format('YYYY-MM-DD'),
        date_end: moment(dataFinalHistorico).format('YYYY-MM-DD'),
        plantoes_ids: filterRegional,
        regional_id: regiaoHistorico?.id ?? null
      }
    })
      .then(res => {
        setHistoricoLeads(res.data.leads);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingHistoricoLeads(false));
  }

  const getEvolucaoLeads = () => {
    setLoadingEvolucaoLeads(true);

    const filterRegional = (plantoesEvolucao.length === totalShiftsNumber)
      ? null
      : plantoesEvolucao.join(',');

    api.get('/leads/evolucao', {
      params: {
        periodo,
        plantoes_ids: filterRegional,
        regional_id: regiaoEvolucao?.id ?? null
      }
    })
      .then(res => {
        setEvolucaoData(res.data.data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingEvolucaoLeads(false));
  }

  const getRankingLeadsAtivados = () => {
    setLoadingRankingLeadsAtivados(true);

    api.get('/leads/ranking-ativacoes', {
      params: {
        date_start: moment(dataInicialRankingAtivados).format('YYYY-MM-DD'),
        date_end: moment(dataFinalRankingAtivados).format('YYYY-MM-DD'),
        regional_id: regiaoRankingAtivados?.id ?? null
      }
    })
      .then(res => {
        let data = {
          corretores: res.data?.corretores ?? [],
          gerentes: res.data?.gerentes ?? [],
          superintendentes: res.data?.superintendentes ?? []
        };
        setRankingLeadsAtivados(data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingRankingLeadsAtivados(false));
  }

  const getRankingLeadsExpirados = () => {
    setLoadingRankingLeadsExpirados(true);

    api.get('/leads/ranking-expiracoes', {
      params: {
        date_start: moment(dataInicialRankingExpirados).format('YYYY-MM-DD'),
        date_end: moment(dataFinalRankingExpirados).format('YYYY-MM-DD'),
        regional_id: regiaoRankingExpirados?.id ?? null
      }
    })
      .then(res => {
        let data = {
          corretores: res.data?.corretores ?? [],
          gerentes: res.data?.gerentes ?? [],
          superintendentes: res.data?.superintendentes ?? []
        };
        setRankingLeadsExpirados(data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingRankingLeadsExpirados(false));
  }

  const handleDateHistorico = (start, final) => {
    setDataInicialHistorico(start);
    setDataFinalHistorico(final);
  }

  const handleDateRankingAtivados = (start, final) => {
    setDataInicialRankingAtivados(start);
    setDataFinalRankingAtivados(final);
  }

  const handleDateRankingExpirados = (start, final) => {
    setDataInicialRankingExpirados(start);
    setDataFinalRankingExpirados(final);
  }

  const getShifts = async (filter = {}) => {

    setLoadingShifts(true);
    const { data, status } = await api.get(`list-plantoes`, {
      params: filter
    });
    let totalShifts = 0;
    let s = [];
    data.regionais.map(regional => {
      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        s.push(plantao.id);
      });
    });

    setTotalShiftsNumber(totalShifts);

    setRegionais(data.regionais);
    setShifts(s);
    setPlantoesHistorico(s);
    setPlantoesEvolucao(s);

    if (status === 200) {
      setLoadingShifts(false);
    }
    if (typeof filter.regional_id === 'undefined' || filter.regional_id === 'null') {
      setTotalShifts(totalShifts);
    }
  }

  const goToMore = (perfil, ranking) => {
    let params = {
      sort_by: ranking,
      sort_dir: 'desc'
    };

    if(ranking === 'ativados'){
      params.start_date = moment(dataInicialRankingAtivados).format('YYYY-MM-DD');
      params.final_date = moment(dataFinalRankingAtivados).format('YYYY-MM-DD');

      if(Object.keys(regiaoRankingAtivados).length > 0){
        params.region_id = regiaoRankingAtivados.id;
        params.region_nome = regiaoRankingAtivados.nome;
        params.region_slug = regiaoRankingAtivados.slug;
      }
    }
    if(ranking === 'expirados'){
      params.start_date = moment(dataInicialRankingExpirados).format('YYYY-MM-DD');
      params.final_date = moment(dataFinalRankingExpirados).format('YYYY-MM-DD');

      if(Object.keys(regiaoRankingExpirados).length > 0){
        params.region_id = regiaoRankingExpirados.id;
        params.region_nome = regiaoRankingExpirados.nome;
        params.region_slug = regiaoRankingExpirados.slug;
      }
    }

    let urlParams = createUrlParamsFromObject(params);

    return `leads/${perfil}?${urlParams}`;
  }

  const getPeriodoFromStringSize = date => {
    let res = '';
    let length = date ? date.length : 0;
    
    switch (length) {
      case 10:
        res = 'diario';
        break;
      case 21:
        res = 'semanal';
        break;
      case 7:
        res = 'mensal';
        break;
    }

    return res;
  }

  const renderCustomAxisTick = ({ x, y, payload }) => {
    let date = payload.value;
    let firstLine = '';
    let secondLine = '';

    switch (getPeriodoFromStringSize(date)) {
      case 'diario':
        firstLine = moment(date).format('ddd').toUpperCase();
        secondLine = moment(date).format('DD/MM');
        break;
      case 'semanal':
        let datas = date.includes(',') ? date.split(',') : [];
        firstLine = moment(datas[0]).format('DD/MM');
        secondLine = moment(datas[1]).format('DD/MM');
        break;
      case 'mensal':
        firstLine = moment(date).format('MMM').toUpperCase();
        secondLine = moment(date).format('YYYY');
        break;
    }
    
    return (
      <>
        <text x={x} y={y + 20} style={{ fontWeight: periodo === 'semanal' ? 'normal' : 'bold', fontSize: 14 }} textAnchor="middle">{firstLine}</text>
        <text x={x} y={y + 40} style={{ fontSize: 14 }} textAnchor="middle">{secondLine}</text>
      </>
    );
  }
  
  const CustomTooltip = ({ active, payload, label }) => {
    switch (getPeriodoFromStringSize(label)) {
      case 'diario':
        label = `${moment(label).format('dddd')}`;
        break;
      case 'semanal':
        let datas = label.split(',');
        label = `${moment(datas[0]).format('DD/MM/YYYY')} a ${moment(datas[1]).format('DD/MM/YYYY')}`;
        break;
      case 'mensal':
        label = moment(label).format('MMMM/YYYY').toUpperCase();
        break;
    }

    if (active && payload && payload.length) {
      return (
        <div className="custom-chart-tooltip">
          <p className="label">{label}</p>
          {payload.map(data => (
            <p className="value" style={{ color: data.color }}>{labels[data.name]} : {data.value.toLocaleString()}</p>
          ))}
        </div>
      );
    }

    return null;
  }

  const renderColorfulLegendText = (value, entry) => {
    const { color } = entry;
    return <span style={{ color, fontSize: 14 }}>{labels[value].toUpperCase()}</span>;
  };

  return (
    <>
      {showModalHistoricoRegiao &&
        <ModalRegion handleClose={() => setShowModalHistoricoRegiao(false)}
          handleRegion={setRegiaoHistorico} />
      }
      {showModalHistoricoPlantoes &&
        <ModalShift
          handleClose={() => setShowModalHistoricoPlantoes(false)}
          handleShift={setPlantoesHistorico}
          shifts={plantoesHistorico}
          region={regiaoHistorico}
        />
      }
      {showModalEvolucaoRegiao &&
        <ModalRegion handleClose={() => setShowModalEvolucaoRegiao(false)}
          handleRegion={setRegiaoEvolucao}
        />
      }
      {showModalEvolucaoPlantoes &&
        <ModalShift handleClose={() => setShowModalEvolucaoPlantoes(false)}
          handleShift={setPlantoesEvolucao}
          shifts={plantoesEvolucao}
          region={regiaoEvolucao}
        />
      }
      {showModalEvolucaoPeriodo &&
        <ModalPeriodo
          handleClose={() => setShowModalEvolucaoPeriodo(false)}
          setPeriodo={setPeriodo}
        />
      }
      {showModalRankingAtivadosRegiao &&
        <ModalRegion handleClose={() => setShowModalRankingAtivadosRegiao(false)}
          handleRegion={setRegiaoRankingAtivados}
        />
      }
      {showModalRankingExpiradosRegiao &&
        <ModalRegion handleClose={() => setShowModalRankingExpiradosRegiao(false)}
          handleRegion={setRegiaoRankingExpirados}
        />
      }

      <section id="content">
        <Header icon={<img src={vv} />} title="Visita Virtual" subtitle=""  />
        <>
        <div className="pd-37">
          {/* <div className="box-alert">
            <p>
              Caro gestor, você está acessando o beta desta funcionalidade. Pela enorme quantidade de dados, estamos validando as funcionalidades junto a nosso time e você está participando dessa nova experiência da dashboard 2.0. <br/>
              Caso encontre alguma divergência da realidade, favor contatar o suporte técnico para avaliarmos.
            </p>
          </div> */}
          <div className="box light-grey">
            <div className="box-header">
              <div className="box-title">
                <div className="box-title-text">
                  <h2>Histórico</h2>
                </div>
              </div>
              <div className="box-tools">
                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalHistoricoRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        <img src={icon[regiaoHistorico?.slug] ?? br} />
                        {<span>{regiaoHistorico?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowModalHistoricoPlantoes(true)}>
                  {loadingHistoricoLeads &&
                    <Loading cWidth={120} cHeight={40} />
                  }
                  {!loadingHistoricoLeads &&
                    <>
                      <img src={pin2} />
                      <span> {plantoesHistorico.length === totalShifts ? `Todos os plantões` : `${plantoesHistorico.length}  ${plantoesHistorico.length === 1 ? 'Plantão selecionado' : 'Plantões selecionados'}`}</span>
                    </>
                  }
                </button>
                <InputDate maxIsToday={true} cStartDate={dataInicialHistorico} cFinalDate={dataFinalHistorico} handleDate={handleDateHistorico} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={3}>
                  <div className="box-card box-card-shifts box-card-height box-card-tooltip">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts colorLightBlue">
                          <span className="n-count">{historicoLeads?.unicos}</span>
                        </div>
                        <span className="desc-count">Leads únicos</span>
                      </div>
                      <div className="example-container">
                        <a data-tooltip-id="tooltip-unicos" data-tooltip-html="É a soma dos leads ativados com os leads que estão aguardando ativação.">
                          <img src={tooltip} alt="Icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <Tooltip id="tooltip-unicos" className="example-diff-arrow" classNameArrow="example-arrow" />
                </Col>
                <Col sm={3}>
                  <div className="box-card box-card-shifts box-card-height box-card-tooltip">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts" id="colorGreen">
                          <span className="n-count">{historicoLeads?.ativados}</span>
                        </div>
                        <span className="desc-count">Leads ativados</span>
                      </div>
                      <div className="example-container">
                        <a data-tooltip-id="tooltip-ativados" data-tooltip-html="São todos os leads que já tiveram seu acionamento, ou seja, foram contactados de alguma forma pelo aplicativo.">
                          <img src={tooltip} alt="Icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <Tooltip id="tooltip-ativados" className="example-diff-arrow" classNameArrow="example-arrow" />
                </Col>
                <Col sm={3}>
                  <div className="box-card box-card-shifts box-card-height box-card-tooltip">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts" id="colorOrange">
                          <span className="n-count">{historicoLeads?.aguardando}</span>
                        </div>
                        <span className="desc-count">Aguardando ativação</span>
                      </div>
                      <div className="example-container">
                        <a data-tooltip-id="tooltip-aguardando" data-tooltip-html="Soma dos leads que estão aguardando ativação pelos corretores.">
                          <img src={tooltip} alt="Icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <Tooltip id="tooltip-aguardando" className="example-diff-arrow" classNameArrow="example-arrow" />
                </Col>
                <Col sm={3}>
                  <div className="box-card box-card-shifts box-card-height box-card-gray box-card-tooltip">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts" id="colorWhite">
                          <span className="n-count">{historicoLeads?.expirados}</span>
                        </div>
                        <span className="desc-count">Expirados</span>
                      </div>
                      <div className="example-container">
                        <a data-tooltip-id="tooltip-expirados" data-tooltip-html="É a soma de todos os leads expirados. Como os leads podem expirar mais de uma vez, esse número não entra na contagem de leads únicos.">
                          <img src={tooltip2} alt="Icon" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <Tooltip id="tooltip-expirados" className="example-diff-arrow" classNameArrow="example-arrow" />
                </Col>
              </Row>
            </div>
          </div>

          <div className="box box-border">
            <Row>
              <Col sm={4}>
                <div className="box-card-body">
                  <h3>Evolução de leads</h3>
                  {userInfo?.isMaster &&
                    <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoRegiao(true)}>
                      {loadingShifts &&
                        <Loading cWidth={120} cHeight={40} />
                      }
                      {!loadingShifts &&
                        <>
                          {<img src={icon[regiaoEvolucao?.slug] ?? br} />}
                          {<span>{regiaoEvolucao?.nome ?? 'Brasil'}</span>}
                        </>
                      }
                    </button>
                  }
                  <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoPlantoes(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        <img src={pin2} />
                        <span> {plantoesEvolucao.length === totalShifts ? `Todos os plantões` : `${plantoesEvolucao.length} ${plantoesEvolucao.length === 1 ? 'Plantão selecionado' : 'Plantões selecionados'}`}</span>
                      </>
                    }
                  </button>
                  <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoPeriodo(true)}>
                    {loadingEvolucaoLeads &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingEvolucaoLeads &&
                      <>
                      {periodo == 'diario' &&
                        <img src={calendar6} />
                      }
                      {periodo == 'semanal' &&
                        <img src={calendar7} />
                      }
                      {periodo == 'mensal' &&
                        <img src={calendar8} />
                      }
                        <span> {periodo == 'diario' ? 'Diário' : periodo} </span>
                      </>
                    }
                  </button>
                </div>
              </Col>
              <Col sm={8}>
                {/* <div className="box-card-body"> */}
                  {loadingEvolucaoLeads &&
                    <Loading cWidth={`100%`} cHeight={400} />
                  }
                  {!loadingEvolucaoLeads &&
                    <>
                      <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                          width={580}
                          height={300}
                          data={evolucaoData}
                        >
                          <CartesianGrid strokeDasharray="1 1" />
                          <XAxis 
                            dataKey="periodo"
                            interval={0}
                            tick={renderCustomAxisTick} 
                          />
                          <YAxis 
                            tickFormatter={tick => {
                              return tick.toLocaleString();
                            }}
                          />
                          <RechartsTooltip content={<CustomTooltip />} cursor={{ fill: '#ECECEC'}} />
                          <Bar dataKey="ativados" stackId="a" barSize={50} fill="#02C39A"/>
                          <Bar dataKey="aguardando" stackId="a" barSize={50} fill="#FF6542"/>
                          <Bar dataKey="expirados" stackId="a" barSize={50} fill="#828282"/>
                          <Legend wrapperStyle={{ bottom: -30 }} height={50} formatter={renderColorfulLegendText}/>
                        </BarChart>
                      </ResponsiveContainer>
                    </>
                  }

                {/* </div> */}
              </Col>
            </Row>
          </div>

          <div className="box dark-blue">
            <div className="box-header">
              <div className="box-title">
                <img src={check2} />
                <h2>Ranking de ativações</h2>
              </div>
              <div className="box-tools">

                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalRankingAtivadosRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        {<img src={icon[regiaoRankingAtivados?.slug] ?? br} />}
                        {<span>{regiaoRankingAtivados?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <InputDate maxIsToday={true} cStartDate={dataInicialRankingAtivados} cFinalDate={dataFinalRankingAtivados}
                  handleDate={handleDateRankingAtivados} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 corretores</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingLeadsAtivados &&
                        <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                      }
                      {!loadingRankingLeadsAtivados &&
                        <>
                          <table className="table-dash">
                            <thead>
                              <tr>
                                <th>Corretor</th>
                                <th>Gerente</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rankingLeadsAtivados?.corretores.map((corretor, key) => (
                                <tr key={key}>
                                  <td>{corretor.apelido}</td>
                                  <td>{corretor?.gerente?.apelido ?? '-'}</td>
                                  <td>{corretor.total.ativados}</td>
                                </tr>
                              ))}
                              {rankingLeadsAtivados.corretores.length === 0 && 
                                <td>
                                  <td colSpan={3}>Nenhum resultado</td>
                                </td>
                              }
                            </tbody>
                          </table>
                          <a href={`${goToMore('corretores', 'ativados')}`}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </>
                      }

                    </div>
                  </div>
                </Col>

                {(userInfo?.isUserEspecial || userInfo?.isSuperintendente || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 gerentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingLeadsAtivados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingLeadsAtivados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Gerente</th>
                                  <th>Sup</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingLeadsAtivados?.gerentes.map((gerente, key) => (
                                  <tr key={key}>
                                    <td>{gerente.apelido}</td>
                                    <td>{gerente?.superintendente?.apelido ?? '-'}</td>
                                    <td>{gerente.total.ativados}</td>
                                  </tr>
                                ))}
                                {rankingLeadsAtivados.gerentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum resultado</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                             <a href={`${goToMore('gerentes', 'ativados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }

                {(userInfo?.isUserEspecial || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 superintendentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingLeadsAtivados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingLeadsAtivados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Sup</th>
                                  <th>Diretor</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingLeadsAtivados?.superintendentes.map((superintendente, key) => (
                                  <tr key={key}>
                                    <td>{superintendente.apelido}</td>
                                    <td>{superintendente?.diretor?.apelido ?? '-'}</td>
                                    <td>{superintendente.total.ativados}</td>
                                  </tr>
                                ))}
                                {rankingLeadsAtivados.superintendentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum resultado</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            <a href={`${goToMore('superintendentes', 'ativados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }
              </Row>
            </div>
          </div>

          <div className="box dark-gray">
            <div className="box-header">
              <div className="box-title">
                <img src={closeCircle} />
                <h2>Ranking de expirações</h2>
              </div>
              <div className="box-tools">

                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalRankingExpiradosRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        {<img src={icon[regiaoRankingExpirados?.slug] ?? br} />}
                        {<span>{regiaoRankingExpirados?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <InputDate maxIsToday={true} cStartDate={dataInicialRankingExpirados} cFinalDate={dataFinalRankingExpirados}
                  handleDate={handleDateRankingExpirados} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 corretores</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingLeadsExpirados &&
                        <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                      }
                      {!loadingRankingLeadsExpirados &&
                        <>
                          <table className="table-dash">
                            <thead>
                              <tr>
                                <th>Corretor</th>
                                <th>Gerente</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rankingLeadsExpirados?.corretores.map((corretor, key) => (
                                <tr key={key}>
                                  <td>{corretor.apelido}</td>
                                  <td>{corretor?.gerente?.apelido ?? '-'}</td>
                                  <td className='red'>{corretor.total.expirados}</td>
                                </tr>
                              ))}
                              {rankingLeadsExpirados.corretores.length === 0 && 
                                <td>
                                  <td colSpan={3}>Nenhum resultado</td>
                                </td>
                              }
                            </tbody>
                          </table>
                           <a href={`${goToMore('corretores', 'expirados')}`}>
                            <img src={plusCircle} />
                            Ver mais
                          </a>
                        </>
                      }

                    </div>
                  </div>
                </Col>

                {(userInfo?.isUserEspecial || userInfo?.isSuperintendente || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 gerentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingLeadsExpirados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingLeadsExpirados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Gerente</th>
                                  <th>Sup</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingLeadsExpirados?.gerentes.map((gerente, key) => (
                                  <tr key={key}>
                                    <td>{gerente.apelido}</td>
                                    <td>{gerente?.superintendente?.apelido ?? '-'}</td>
                                    <td className='red'>{gerente.total.expirados}</td>
                                  </tr>
                                ))}
                                {rankingLeadsExpirados.gerentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum resultado</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            <a href={`${goToMore('gerentes', 'expirados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }

                {(userInfo?.isUserEspecial || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 superintendentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingLeadsExpirados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingLeadsExpirados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Sup</th>
                                  <th>Diretor</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingLeadsExpirados?.superintendentes.map((superintendente, key) => (
                                  <tr key={key}>
                                    <td>{superintendente.apelido}</td>
                                    <td>{superintendente?.diretor?.apelido ?? '-'}</td>
                                    <td className='red'>{superintendente.total.expirados}</td>
                                  </tr>
                                ))}
                                {rankingLeadsExpirados.superintendentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum resultado</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            <a href={`${goToMore('superintendentes', 'expirados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }
              </Row>
            </div>
          </div>
        </div>
        </>
      </section>
    </>
  );

}

export default Leads;